import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import { Reveal, Kicker } from "@/components/site/Reveal";
import { usePageMeta } from "@/lib/seo";

export default function AgilitePage() {
  usePageMeta("L'Agilité — Le blog", "Articles et retours d'expérience sur l'agilité, l'ingénierie des exigences et l'amélioration des processus, par ASAP Technologies et Reqen.");
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => {});
  }, []);

  return (
    <main className="bg-[#0b0f19] min-h-screen" data-testid="agilite-page">
      <Nav />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24">
        <Reveal>
          <Kicker>Le blog du partenariat</Kicker>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-50">
            L'<span className="grad-text">Agilité</span>
          </h1>
          <p className="mt-5 text-slate-400 max-w-xl text-sm sm:text-base leading-relaxed">
            Nos convictions, retours d'expérience et éclairages sur l'agilité, l'ingénierie des
            exigences et l'amélioration des processus. De nouveaux articles sont publiés régulièrement.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {articles.map((a, i) => (
            <Reveal key={a.article_id} delay={i * 0.06}>
              <Link
                to={`/agilite/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="block border border-white/10 bg-[#131b2c] card-lift h-full overflow-hidden"
              >
                {a.image_url && <img src={a.image_url} alt={a.title} className="w-full h-40 object-cover opacity-70" />}
                <div className="p-6">
                  <div className="text-[11px] font-mono2 uppercase tracking-[0.2em] text-blue-400">
                    {a.category} · {a.read_time}
                  </div>
                  <h3 className="mt-3 font-heading text-lg font-semibold text-slate-100 leading-snug">{a.title}</h3>
                  <p className="mt-2 text-sm text-slate-500 line-clamp-3">{a.excerpt}</p>
                  <span className="mt-4 inline-block text-sm text-teal-300">Lire l'article →</span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        {articles.length === 0 && <p className="mt-14 text-sm text-slate-500">Les premiers articles arrivent bientôt.</p>}
      </div>
      <Footer />
    </main>
  );
}
